import {
    Component,
    ElementRef,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { WellHealthinessService } from 'app/modules/well-healthiness/services/well-healthiness.service';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { removeAmChartLogo } from 'app/core/shared/amchart4/amchart4.module';
import module from 'app/modules/well-healthiness/well-healthiness.module';
import { WellHealthinessCategoryResponse } from 'app/modules/well-healthiness/model';

am4core.useTheme(am4themes_animated);

@Component({
    selector: 'app-well-wh-category',
    templateUrl: './wh-category.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: module,
    styleUrls: ['./wh-category.component.scss'],
})
export class WhCategoryComponent implements OnChanges {
    @Input() data: WellHealthinessCategoryResponse;

    constructor(
        private readonly elementRef: ElementRef,
        public service: WellHealthinessService,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['data'] && this.data?.data?.items) {
            this.healthinessChart();
        }
    }

    private healthinessChart() {
        // Create chart instance
        let chart = am4core.create('whHealthinessChart', am4charts.XYChart);

        // Transform data from API response
        chart.data = this.data.data.items.map((item) => ({
            category: item.category,
            count: item.count,
            // color: '#fffff'
        }));

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = 'category';
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.fill = am4core.color('#000');

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.labels.template.rotation = 0; // Set rotation to 0 for horizontal labels
        valueAxis.title.text = 'Number of String'; // Rename Y-axis
        valueAxis.renderer.labels.template.fill = am4core.color('#000');

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = 'count';
        series.dataFields.categoryX = 'category';
        series.name = 'Counts';
        series.columns.template.tooltipText = '{categoryX}: [bold]{valueY}[/]';
        series.columns.template.fillOpacity = 0.8;
        // series.fill = am4core.color('color');

        chart.legend = new am4charts.Legend();
        chart.legend.position = 'bottom';
        chart.legend.valign = 'bottom';
        chart.legend.contentAlign = 'center';
        chart.legend.labels.template.fontSize = 12;
        chart.legend.labels.template.fill = am4core.color('#000');
        chart.legend.itemContainers.template.paddingTop = 0;
        chart.legend.itemContainers.template.paddingBottom = 0;
        chart.legend.marginTop = 20;
        chart.legend.valueLabels.template.disabled = true;

        // Custom marker style
        chart.legend.markers.template.width = 12;
        chart.legend.markers.template.height = 12;
        let markerTemplate = chart.legend.markers.template.children.getIndex(
            0,
        ) as am4core.RoundedRectangle;
        markerTemplate.cornerRadius(4, 4, 4, 4);

        let columnTemplate = series.columns.template;
        columnTemplate.strokeWidth = 2;
        columnTemplate.strokeOpacity = 1;

        removeAmChartLogo(this.elementRef.nativeElement);
    }
}
